/* eslint-disable no-nested-ternary*/
//fixes the "Unicode Problem": This solution consists in converting a JavaScript's native UTF-16 string into a UTF-8 string and then encoding the latter into base64.
//source: https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#Solution_2_%E2%80%93_JavaScript's_UTF-16_%3E_UTF-8_%3E_base64



/*\
|*|
|*|  Base64 / binary data / UTF-8 strings utilities (#2)
|*|
|*|  https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding
|*|
|*|  Author: madmurphy
|*|
\*/

/* Base64 string to array encoding */
const uint6ToB64 = nUint6 => {
  return nUint6 < 26 ?
    nUint6 + 65
    : nUint6 < 52 ?
      nUint6 + 71
      : nUint6 < 62 ?
        nUint6 - 4
        : nUint6 === 62 ?
          43
          : nUint6 === 63 ?
            47
            : 65;
};

/* encode to base64 */
const base64EncArr = aBytes => {
  const eqLen = (3 - (aBytes.length % 3)) % 3;
  let sB64Enc = '';

  for (let nMod3, nLen = aBytes.length, nUint24 = 0, nIdx = 0; nIdx < nLen; nIdx++) {
    nMod3 = nIdx % 3;
    /* Uncomment the following line in order to split the output in lines 76-character long: */
    /*
		if (nIdx > 0 && (nIdx * 4 / 3) % 76 === 0) { sB64Enc += "\r\n"; }
		*/
    nUint24 |= aBytes[nIdx] << (16 >>> nMod3 & 24);
    if (nMod3 === 2 || aBytes.length - nIdx === 1) {
      sB64Enc += String.fromCharCode(uint6ToB64(nUint24 >>> 18 & 63), uint6ToB64(nUint24 >>> 12 & 63), uint6ToB64(nUint24 >>> 6 & 63), uint6ToB64(nUint24 & 63));
      nUint24 = 0;
    }
  }

  return eqLen === 0 ?
    sB64Enc
    :
    sB64Enc.substring(0, sB64Enc.length - eqLen) + (eqLen === 1 ? '=' : '==');
};

const strToUTF8Arr = sDOMStr => {
  /* DOMString to UTF-8 array */
  let nChr;
  const nStrLen = sDOMStr.length;
  let nArrLen = 0;

  /* mapping... */
  for (let nMapIdx = 0; nMapIdx < nStrLen; nMapIdx++) {
    nChr = sDOMStr.charCodeAt(nMapIdx);
    nArrLen += nChr < 0x80 ? 1 : nChr < 0x800 ? 2 : nChr < 0x10000 ? 3 : nChr < 0x200000 ? 4 : nChr < 0x4000000 ? 5 : 6;
  }

  const aBytes = new Uint8Array(nArrLen);

  /* transcription... */
  for (let nIdx = 0, nChrIdx = 0; nIdx < nArrLen; nChrIdx++) {
    nChr = sDOMStr.charCodeAt(nChrIdx);
    if (nChr < 128) {
      /* one byte */
      aBytes[nIdx++] = nChr;
    } else if (nChr < 0x800) {
      /* two bytes */
      aBytes[nIdx++] = 192 + (nChr >>> 6);
      aBytes[nIdx++] = 128 + (nChr & 63);
    } else if (nChr < 0x10000) {
      /* three bytes */
      aBytes[nIdx++] = 224 + (nChr >>> 12);
      aBytes[nIdx++] = 128 + (nChr >>> 6 & 63);
      aBytes[nIdx++] = 128 + (nChr & 63);
    } else if (nChr < 0x200000) {
      /* four bytes */
      aBytes[nIdx++] = 240 + (nChr >>> 18);
      aBytes[nIdx++] = 128 + (nChr >>> 12 & 63);
      aBytes[nIdx++] = 128 + (nChr >>> 6 & 63);
      aBytes[nIdx++] = 128 + (nChr & 63);
    } else if (nChr < 0x4000000) {
      /* five bytes */
      aBytes[nIdx++] = 248 + (nChr >>> 24);
      aBytes[nIdx++] = 128 + (nChr >>> 18 & 63);
      aBytes[nIdx++] = 128 + (nChr >>> 12 & 63);
      aBytes[nIdx++] = 128 + (nChr >>> 6 & 63);
      aBytes[nIdx++] = 128 + (nChr & 63);
    } else /* if (nChr <= 0x7fffffff) */ {
      /* six bytes */
      aBytes[nIdx++] = 252 + (nChr >>> 30);
      aBytes[nIdx++] = 128 + (nChr >>> 24 & 63);
      aBytes[nIdx++] = 128 + (nChr >>> 18 & 63);
      aBytes[nIdx++] = 128 + (nChr >>> 12 & 63);
      aBytes[nIdx++] = 128 + (nChr >>> 6 & 63);
      aBytes[nIdx++] = 128 + (nChr & 63);
    }
  }
  return aBytes;
};
//end "Unicode Problem" code


import templates from '_shared_/utils/excel-xml';

const templateMapping = {
  excel: templates.templateExcelWorksheet,
  html: templates.templateHTMLWorksheet,
  list: templates.templateListWorksheet,
  workbook: templates.templateWorkBook
};

const refsToLiterals = (s, c) => {
  return templateMapping[s].replace(/{(\w+)}/g, (m, p) => {
    return c[p];
  });
};

const unicodeToHTML = text => {
  //replace en-dash with single-dash
  text = text.replace(/\u2013/g, '-');
  //replace misread é with HTML (e.g., NestlÃ© -> Nestlé)
  text = text.replace(/\u00e9/g, '&eacute;');
  //replace misread ™ (e.g., Ratingâ„¢ -> Rating™)
  text = text.replace(/\u2122/g, '&trade;');
  //replace misread ® (e.g., InvestingÂ® -> Investing®)
  text = text.replace(/\u00ae/g, '&reg;');
  return text;
};

const encoders = {
  base64EncArr,
  refsToLiterals,
  strToUTF8Arr,
  unicodeToHTML
};

export default encoders;
